import React from 'react';
import { View } from 'react-native';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectIsCreditScoreSpotlightActive, selectIsInvestWalkthroughActive, selectIsPayFeedSpotlightActive, } from 'reducers/selectors/walkthrough';
import { assertUnreachable } from 'utils';
const WalkthroughOverlay = ({ context = 'feed', style }) => {
    const styles = useStyles(styleSet);
    const status = useAppSelector((store) => store.feed.walkthrough?.status);
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    const showNotificationsWalkThrough = useAppSelector((store) => store.walkthrough.showNotificationsWalkThrough);
    const isCreditScoreSpotlightActive = useAppSelector(selectIsCreditScoreSpotlightActive);
    const isPayFeedSpotlightActive = useAppSelector(selectIsPayFeedSpotlightActive);
    let show = false;
    if (context === 'feed') {
        show = status === 'in-progress';
    }
    else if (context === 'invest') {
        show = isInvestWalkthroughActive;
    }
    else if (context === 'notifications') {
        show = showNotificationsWalkThrough;
    }
    else if (context === 'credit-score') {
        show = isCreditScoreSpotlightActive;
    }
    else if (context === 'pay-feed') {
        show = isPayFeedSpotlightActive;
    }
    else {
        assertUnreachable(context);
    }
    return show ? <View style={[styles.container, style]}/> : null;
};
const styleSet = createStyleSheets(() => ({
    container: {
        position: 'absolute',
        opacity: 0.8,
        backgroundColor: '#000',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
}));
export default WalkthroughOverlay;
